import { styled } from '@mui/material/styles';

const PREFIX = 'withDialog';

export const classes = {
  root: `${PREFIX}-root`,
  dialogActions: `${PREFIX}-dialogActions`,
  addDateButton: `${PREFIX}-addDateButton`,
  dialogWidget: `${PREFIX}-dialogWidget`,
  dialogIcon: `${PREFIX}-dialogIcon`,
  /** Keeps ledger icon slot width during PDF export while hiding visually */
  dialogIconExportHidden: `${PREFIX}-dialogIconExportHidden`,
};

export const Root = styled('div')(({ theme }) => ({
  width: '100%',
  [`& .${classes.root}`]: {
    width: '100%',
  },

  [`& .${classes.dialogActions}`]: {
    padding: theme.spacing(3),
  },

  [`& .${classes.addDateButton}`]: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },

  [`& .${classes.dialogWidget}`]: {
    display: 'flex',
  },

  [`& .${classes.dialogIcon}`]: {},

  [`& .${classes.dialogIconExportHidden}`]: {
    visibility: 'hidden',
    pointerEvents: 'none',
  },
}));
